import { EGroupedItemsType } from '~/src/services/properties';

export const columnConfig = {
    label: {
        label: '',
        type: EGroupedItemsType.Title,
    },
    properties: {
        name: 'properties',
        items: {
            sortOrder: {
                name: 'sortOrder',
                label: 'Сортировка',
                type: EGroupedItemsType.String,
                order: 1,
            },
            backgroundColor: {
                name: 'backgroundColor',
                label: 'Цвет фона',
                type: EGroupedItemsType.ColorPicker,
                order: 2,
            },
            paddingVertical: {
                name: 'paddingVertical',
                label: 'Вертикальный отступ',
                type: EGroupedItemsType.Margin,
                order: 2,
            },
            paddingHorizontal: {
                name: 'paddingHorizontal',
                label: 'Горизонтальный отступ',
                type: EGroupedItemsType.Margin,
                order: 2,
            },
            borderRadius: {
                name: 'borderRadius',
                label: 'Border Radius',
                type: EGroupedItemsType.Margin,
                order: 2,
            },
            removeElement: {
                name: 'removeElement',
                label: 'Удалить колонку',
                type: EGroupedItemsType.ButtonRemove,
                order: 3,
            },
        },
    },
};
